<template>
  <v-col class="pa-8">
    <v-row>
      <v-col>
        <h3 class="grey-color mx-4" style="font-weight: 500">Overview</h3>
      </v-col>
    </v-row>
    <v-row class="ma-0" justify="center">
      <v-col cols="12" md="4" class="px-0">
        <!-- <v-btn @click="updateBots()">Update</v-btn> -->
        <v-row class="ma-0 mx-4" justify="center">
          <div style="height: 400px" class="white-card pa-4">
            <v-row class="ma-0">
              <h3 class="my-1">Visitors</h3>
              <v-chip
                class="mx-4"
                :class="{
                  redChip: visitorsPercentageChange < 0,
                  greenChip: visitorsPercentageChange > 0,
                }"
              >
                <v-icon
                  v-if="visitorsPercentageChange < 0"
                  style="color: black"
                  class="mx-1"
                  small
                >mdi-arrow-down-circle</v-icon>
                <v-icon
                  v-if="visitorsPercentageChange > 0"
                  style="color: black"
                  class="mx-1"
                  small
                >mdi-arrow-up-circle</v-icon>
                <p style="color: black">{{ visitorsPercentageChange }}%</p>
              </v-chip>
            </v-row>
            <!-- <v-row justify="end" class="ma-0">
              <v-select
                dense
                class="mt-0 pt-0 input"
                :hide-details="true"
                style="max-width: 120px !important;"
              >
              </v-select>
            </v-row>-->
            <v-row justify="center">
              <apexchart
                type="bar"
                height="200"
                width="100%"
                :options="chartOptionsVisitors"
                :series="seriesVisitors"
              ></apexchart>
            </v-row>
            <!-- <v-row justify="center" class="ma-0 pt-4">
              <v-btn rounded dark color="#e022d1">
                <v-icon> mdi-alert-circle </v-icon>
                <p class="mx-2 alert-btn">26% NEW VISITORS FROM RSA</p>
              </v-btn>
            </v-row>-->
          </div>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-row class="ma-0 mx-1" justify="center">
          <div style="height: 400px" class="white-card pa-4">
            <v-row justify="center" class="ma-0">
              <v-col cols="6" class="pa-0">
                <v-row justify="start" class="ma-0">
                  <h3>Weekly Average New Sales</h3>
                </v-row>
                <v-row justify="start" class="ma-0">
                  <h1 style="font-weight: 400" class="blue-color">R{{ earningsInLastWeek }}</h1>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-row class="ma-0" justify="end">
                  <h3>Sales</h3>
                  <v-chip
                    class="mx-4"
                    :class="{
                      redChip: earningsPercentageChange < 0,
                      greenChip: earningsPercentageChange > 0,
                    }"
                  >
                    <v-icon
                      v-if="earningsPercentageChange < 0"
                      style="color: black"
                      class="mx-1"
                      small
                    >mdi-arrow-down-circle</v-icon>
                    <v-icon
                      v-if="earningsPercentageChange > 0"
                      style="color: black"
                      class="mx-1"
                      small
                    >mdi-arrow-up-circle</v-icon>
                    <p style="color: black">{{ earningsPercentageChange }}%</p>
                  </v-chip>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="center">
              <apexchart
                type="bar"
                height="280"
                width="150%"
                :options="chartOptionsEarnings"
                :series="seriesEarnings"
              ></apexchart>
            </v-row>
          </div>
        </v-row>
      </v-col>
      <v-col cols="12" md="2" class="px-0">
        <v-row class="ma-0 mx-4" justify="center">
          <div style="height: 400px" class="white-card pa-4">
            <v-col>
              <v-row justify="center">
                <div style="height: 170px; width: 80%" class="blue-card">
                  <v-row justify="center" class="my-8">
                    <v-icon x-large color="white">mdi-blur-radial</v-icon>
                  </v-row>
                  <v-row justify="center">
                    <p class="white-color">Online</p>
                  </v-row>
                  <v-row justify="center">
                    <p class="white-color">({{ onlines }})</p>
                  </v-row>
                </div>
              </v-row>
              <v-row justify="center" class="mt-8">
                <div style="height: 170px; width: 80%" class="blue-card">
                  <v-row justify="center" class="my-8">
                    <v-icon x-large color="white">mdi-map-marker</v-icon>
                  </v-row>
                  <v-row justify="center">
                    <p class="white-color">Call Out</p>
                  </v-row>
                  <v-row justify="center">
                    <p class="white-color">({{ callouts }})</p>
                  </v-row>
                </div>
              </v-row>
            </v-col>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center" class="ma-0">
      <v-col cols="12" md="6">
        <v-row justify="center" class="mx-1">
          <div class="white-card pa-8 mb-6">
            <v-row justify="center">
              <h3>Service Activity</h3>
            </v-row>
            <v-col class="typesHolder">
              <v-row v-for="type in consultTypes" :key="type" class="mx-12 mt-12">
                <v-col cols="6">
                  <v-row justify="start">
                    <p>{{ type.name }}</p>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row justify="end">
                    <h4 class="fs400" style="color: green">{{ type.count }}</h4>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-row justify="center">
          <v-col cols="12" md="4" class="pb-6">
            <v-row justify="center" class="mx-1">
              <div class="white-card pa-2" style="height: 180px">
                <v-row justify="center">
                  <v-icon class="pink-color icon mt-4">mdi-account</v-icon>
                </v-row>
                <v-row justify="center">
                  <p>Users</p>
                </v-row>
                <v-row justify="center">
                  <h2 style="color: green" class="fs400">{{ clients.length }}</h2>
                </v-row>
              </div>
            </v-row>
          </v-col>
          <v-col cols="12" md="4" class="pb-6">
            <v-row justify="center" class="mx-1">
              <div class="white-card pa-2" style="height: 180px">
                <v-row justify="center">
                  <v-icon class="pink-color icon mt-4">mdi-doctor</v-icon>
                </v-row>
                <v-row justify="center">
                  <p>Doctors</p>
                </v-row>
                <v-row justify="center">
                  <h2 style="color: green" class="fs400">{{ doctors.length }}</h2>
                </v-row>
              </div>
            </v-row>
          </v-col>
          <v-col cols="12" md="4" class="pb-6">
            <v-row justify="center" class="mx-1">
              <div class="white-card pa-2" style="height: 180px">
                <v-row justify="center">
                  <v-icon class="pink-color icon mt-4">mdi-car</v-icon>
                </v-row>
                <v-row justify="center">
                  <p>Admin Users</p>
                </v-row>
                <v-row justify="center">
                  <h2 style="color: green" class="fs400">{{ admins.length }}</h2>
                </v-row>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  updateDoc,
  getDoc,
  doc,
  addDoc
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  name: "Home",
  data() {
    return {
      seriesVisitors: [
        {
          name: "Visitors",
          data: [0, 0, 0, 0, 0, 0, 0]
        }
      ],
      chartOptionsVisitors: {
        chart: {
          type: "bar",
          height: 250
        },
        colors: ["#4390c0"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "60%",
            borderRadius: 5,
            borderRadiusApplication: "end"
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: false,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
        },
        yaxis: {},
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            }
          }
        }
      },
      seriesEarnings: [
        {
          name: "Earnings",
          data: [0, 0, 0, 0, 0, 0, 0]
        }
      ],
      chartOptionsEarnings: {
        chart: {
          type: "bar",
          height: 250
        },
        colors: ["#4390c0"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "90%",
            borderRadius: 5,
            borderRadiusApplication: "end"
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: false,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
        },
        yaxis: {},
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            }
          }
        }
      },
      admins: [],
      doctors: [],
      clients: [],
      loading: false,
      activities: [],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      earningsInLastWeek: 0,
      earningsInPreviousWeek: 0,
      latestVisitors: 0,
      previousVisitors: 0,
      visitorsPercentageChange: 0,
      earningsPercentageChange: 0
    };
  },
  components: {},
  async created() {
    let res = await this.getAdminUsers();
    let res2 = await this.getDoctors();
    let res3 = await this.getClients();
    this.getActivities();
  },
  methods: {
    async getActivities() {
      try {
        let q = query(collection(db, "consultations"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.activities = [];

        const clientMap = Object.fromEntries(this.clients.map(c => [c.id, c]));

        const doctorMap = Object.fromEntries(this.doctors.map(d => [d.id, d]));

        let visitorData = [0, 0, 0, 0, 0, 0, 0];
        let earningsData = [0, 0, 0, 0, 0, 0, 0];

        querySnapshot.docs.forEach(doc => {
          let tempActivity = doc.data();
          tempActivity.id = doc.id;

          // Find client
          const client = clientMap[tempActivity.clientID];
          if (client) {
            tempActivity.client = client;
            tempActivity.clientFullName = `${client.firstName} ${client.lastName}`;
          } else {
            tempActivity.clientFullName = "Client not found";
          }

          tempActivity.patientName = "";

          if (!tempActivity.patient.type) {
            tempActivity.patientName =
              tempActivity.patient.firstName +
              " " +
              tempActivity.patient.lastName;
          } else {
            tempActivity.patientName = tempActivity.patient.name;
          }

          // Find doctor
          const doctor = doctorMap[tempActivity.doctorID];
          if (doctor) {
            tempActivity.doctor = doctor;
            tempActivity.doctorFullName = `${doctor.name} ${doctor.surname}`;
          } else {
            tempActivity.doctorFullName = "Doctor not found";
          }

          tempActivity.dayName = this.days[
            new Date(tempActivity.date).getDay()
          ];

          const dayIndex = new Date(tempActivity.date).getDay();
          visitorData[dayIndex] = (visitorData[dayIndex] || 0) + 1;

          if (tempActivity.paidAmount) {
            let totalAmount = tempActivity.paidAmount * 0.25;

            if (tempActivity.additionalCharges) {
              tempActivity.additionalCharges.forEach(cost => {
                if (cost.amount) {
                  totalAmount += cost.amount * 0.25;
                }
              });
            }

            earningsData[dayIndex] =
              (earningsData[dayIndex] || 0) + totalAmount;

            const activityDate = new Date(tempActivity.date);
            const today = new Date();
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(today.getDate() - 7);

            const twoWeeksAgo = new Date();
            twoWeeksAgo.setDate(today.getDate() - 14);

            if (activityDate >= sevenDaysAgo && activityDate <= today) {
              this.latestVisitors++;
              this.earningsInLastWeek += totalAmount;
            }

            if (activityDate >= twoWeeksAgo && activityDate <= sevenDaysAgo) {
              this.previousVisitors++;
              this.earningsInPreviousWeek += totalAmount;
            }
          }

          this.activities.push(tempActivity);
        });

        this.seriesVisitors = [
          {
            name: "Visitors",
            data: visitorData
          }
        ];

        this.seriesEarnings = [
          {
            name: "Earnings",
            data: earningsData
          }
        ];

        console.log("latestVisitors: ", this.latestVisitors);
        console.log("previousVisitors: ", this.previousVisitors);

        this.visitorsPercentageChange = parseInt(
          ((this.latestVisitors - this.previousVisitors) /
            this.previousVisitors) *
            100
        );

        if (this.latestVisitors == 0 || this.previousVisitors == 0) {
          this.visitorsPercentageChange = 0;
        }

        this.earningsPercentageChange = parseInt(
          ((this.earningsInLastWeek - this.earningsInPreviousWeek) /
            this.earningsInPreviousWeek) *
            100
        );

        if (this.earningsInLastWeek == 0 || this.earningsInPreviousWeek == 0) {
          this.earningsPercentageChange = 0;
        }
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    async getAdminUsers() {
      try {
        let q = query(collection(db, "dashboardUsers"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.admins = [];

        querySnapshot.docs.forEach(doc => {
          let tempUser = doc.data();
          tempUser.id = doc.id;
          this.admins.push(tempUser);
        });
      } catch (error) {
        console.log("error: ", error);
        this.loading = false;
      }
    },
    async getDoctors() {
      try {
        let q = query(collection(db, "doctors"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.doctors = [];

        querySnapshot.docs.forEach(doc => {
          let tempUser = doc.data();
          tempUser.id = doc.id;
          this.doctors.push(tempUser);
        });
      } catch (error) {
        console.log("error: ", error);
        this.loading = false;
      }
    },
    async getClients() {
      try {
        let q = query(collection(db, "clients"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.users = [];

        querySnapshot.docs.forEach(doc => {
          let tempUser = doc.data();
          tempUser.id = doc.id;
          this.clients.push(tempUser);
        });
      } catch (error) {
        console.log("error: ", error);
        this.loading = false;
      }
    },
    async updateBots() {
      try {
        const botsRef = collection(db, "doctorProfileUpdates");
        const q = query(botsRef);
        const querySnapshot = await getDocs(q);

        querySnapshot.docs.forEach(async tempDoc => {
          let bot = tempDoc.data();
          bot.id = tempDoc.id;

          if (bot.subscription) {
            let tempSub = bot.subscription;

            tempSub.consultsExpiry = new Date("2200-12-31");

            if (tempSub.packageName == "Free") {
              const botRef = doc(db, "doctorProfileUpdates", bot.id);
              await updateDoc(botRef, {
                subscription: tempSub
              });
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    callouts() {
      let count = 0;

      this.activities.forEach(activity => {
        if (
          activity.consultType == "Callout" &&
          !activity.denied &&
          !activity.refundApproved
        ) {
          count++;
        }
      });

      return count;
    },
    onlines() {
      let count = 0;

      this.activities.forEach(activity => {
        if (
          activity.consultType == "Online" &&
          !activity.denied &&
          !activity.refundApproved
        ) {
          count++;
        }
      });

      return count;
    },
    consultTypes() {
      let types = [];

      this.activities.forEach(activity => {
        let typeExists = types.find(type => type.name == activity.doctorType);

        if (typeExists) {
          typeExists.count++;
        } else {
          types.push({
            name: activity.doctorType,
            count: 1
          });
        }
      });

      return types.sort((a, b) => b.count - a.count);
    }
  }
};
</script>

<style scoped>
.alert-btn {
  font-size: 10px;
  font-weight: 400;
}

.redChip {
  background: rgba(255, 0, 0, 0.15) !important;
}

.greenChip {
  background: greenyellow !important;
}

.icon {
  font-size: 100px;
}

.typesHolder {
  max-height: 30vh;
  overflow-y: scroll;
}
</style>
